import { memo } from "react";
import GridGappedContainer, {
  GridGappedContainerDirection,
  GridGappedContainerSize,
} from "../../../common/components/GridGappedContainer/GridGappedContainer";
import { SALES_REP_PHONE_NO } from "../../../utils/constants";
import { Trans, useTranslation } from "react-i18next";
import DisclaimerCountryOrigin from "../../../common/components/Messages/DisclaimerCountryOrigin";
import { URL_CONTACT_US } from "../../../utils/url/staticUrls";
import { useSelector } from "react-redux";
import { IncludesSurchargeDisclaimer } from "../../../common/components/Messages/IncludesSurchargeDisclaimer";
import { selectCartContainsSurcharge, selectCartContainsTariffSurcharge } from "~/Cart/redux/selectors/selectors";
import { Alert } from "~/common/m3/Alert/Alert";

export const CHECKOUT_DISCLAIMER_ID = "disclaimer";
const CheckoutFooter = () => {
  const hasAnySurcharge = useSelector(selectCartContainsSurcharge);
  const hasAnyTariffSurcharge = useSelector(selectCartContainsTariffSurcharge);

  const { t } = useTranslation();

  return (
    <div id={CHECKOUT_DISCLAIMER_ID} className={"mt-30"}>
      <GridGappedContainer direction={GridGappedContainerDirection.COLUMN} gapSize={GridGappedContainerSize.S_10}>
        <DisclaimerCountryOrigin />
        <Alert severity="info">
          <Trans i18nKey="checkoutPage.disclaimer.two">
            Need help with your checkout process?
            <a href={URL_CONTACT_US} target="_blank">
              Contact us
            </a>
            or call phone number {{ phoneNo: SALES_REP_PHONE_NO }}
          </Trans>
        </Alert>
      </GridGappedContainer>
      {
        <IncludesSurchargeDisclaimer
          hasSurcharge={hasAnySurcharge}
          tariffSurcharge={hasAnyTariffSurcharge}
          className={"mt-30"}
        />
      }
    </div>
  );
};

export default memo(CheckoutFooter);
